import React, { Component } from 'react';
import Paper from 'material-ui/Paper';
import AvPlayCircleOutline from 'material-ui/svg-icons/av/play-circle-outline';
import AvPlayListAdd from 'material-ui/svg-icons/av/playlist-add';
import ContentLink from 'material-ui/svg-icons/content/link';
import ActionFavoriteBorder from 'material-ui/svg-icons/action/favorite-border';
import IconButton from 'material-ui/IconButton';
import MediaControl from './MediaControl';
import Common from './Common';
import MainToolbar from './MainToolbar';
import Loading from './Loading';
import ModeToolbar from './ModeToolbar';
import PageTab from './PageTab';
import copy from 'copy-to-clipboard';
import Snackbar from 'material-ui/Snackbar';
import SocialGroup from 'material-ui/svg-icons/social/group';
import ActionHistory from 'material-ui/svg-icons/action/history';
import MediaRelation from './MediaRelation';
import FlatButton from 'material-ui/FlatButton';
import Dialog from 'material-ui/Dialog';
import {
  ShareButtons,
  generateShareIcon
} from 'react-share';

const {
  FacebookShareButton
} = ShareButtons;

const FacebookIcon = generateShareIcon('facebook');
var QRCode = require('qrcode.react');
var html2canvas = require('html2canvas');

class Main extends Component {

  constructor(props) {
    super(props);
    this.state = {
      searchText: '',
      searchResults: [],
      myLikes: {},
      myPlayList: {},
      loading: 'hide',
      mode: 'daily',
      snackOpen: false,
      snackMessage: '',
      qrOpen: false,
      qrMediaObj: null,
      qrShareUrl: null,
      qrActions: null
    };
    this.page = 1;
    this.pageSize = 1;
    this.keyboardValue = '';
    this.payloadList = [];
    this.dataSource = {};
    this.payloadRunning = false;
    Common.getTempToken().then(() => {});
  }

  handleUpdateInput(textInput) {
    this.keyboardValue = textInput;
  }

  componentDidMount() {

    Common.initLang(this).then(() => {
      this.mainToolbar.setAutoComplete();
      this.setLikeAndPlayList();
      var pathSplit = window.location.href.split('?q=');
      if (pathSplit.length > 1) {
        this.actionSearch(pathSplit[1], 'detail').then(() => {});
      }
      else {
        this.actionSearch(this.keyboardValue).then(() => {});
      }
    });
  }

  setLikeAndPlayList() {
    var myLikesB = localStorage.getItem('myLikes');
    if (myLikesB) {
      localStorage.setItem('myLikesTH',myLikesB);
      localStorage.removeItem('myLikes');
    }
    var myPlayListB = localStorage.getItem('myPlayList');
    if (myPlayListB) {
      localStorage.setItem('myPlayListTH',myPlayListB);
      localStorage.removeItem('myPlayList');
    }

    var myLikes = localStorage.getItem('myLikes' + localStorage.getItem('lang'));
    var myPlayList = localStorage.getItem('myPlayList' + localStorage.getItem('lang'));
    this.setState({
      myLikes: myLikes ? JSON.parse(myLikes) : {},
      myPlayList: myPlayList ? JSON.parse(myPlayList) : {}
    })

  }

  changePage(index) {
    this.page = index;
    Common.getTempToken().then((token) => {
      this.actionSearch(this.mainToolbar.state.searchText, this.modeToolbar.state.mode, true, { token: token });
    });
  }

  actionSearch(searchText, inpMode, noResetPage, option) {
    var mode = 'daily';
    if (!noResetPage) {
      this.page = 1;
    }
    if (inpMode !== 'detail') {
      if (window.history.replaceState) {
        window.history.replaceState('', 'DhammaLife', '/');
      }
    }
    return new Promise((resolve, reject) => {
      var self = this;
      var needOnline = !self.dataSource.daily || searchText !== "" || inpMode === 'like' || inpMode === 'history';
      if (needOnline) {
        mode = inpMode ? inpMode : (searchText !== "" ? 'search': mode);
        self.modeToolbar.setMode(mode);
        self.loading.showLoading();
        var inpData = {
          funct: 'getDhamma',
          q: searchText
        }
        if (mode === 'person') {
          inpData['page'] = this.page;
        }
        else if (mode === 'like') {
          inpData['page'] = this.page;
          inpData['topic'] = 'like';
          inpData['token'] = option.token;
        }
        else if (mode === 'history') {
          inpData['page'] = this.page;
          inpData['topic'] = 'history';
          inpData['token'] = option.token;
        }
        else if (mode === 'detail') {
          inpData['detail'] = '1';
        }
        inpData['site'] = window.localStorage.getItem('lang');
        Common.getDataFromService(inpData).then((data) => {
            setTimeout(() => {
              self.loading.closeLoading();
              if (!self.dataSource.daily && mode !== 'detail') {
                if (Array.isArray(data)) {
                  self.dataSource.daily = data;
                  self.dataSource.popular = data;
                }
                else {
                  self.dataSource = data;
                }
                self.modeToolbar.setMode(mode);
                window.scrollTo(0, 0);
                self.setState({
                  searchResults: self.dataSource[mode]
                });
              }
              else {
                window.scrollTo(0, 0);
                var results = data;
                if (data.data) {
                  results = data.data;
                  self.pageSize = data.pageSize;
                  if (mode === 'like') {
                    self.renewLike(results);
                  }
                }
                self.setState({
                  searchResults: results,
                });
                if (mode === 'detail' & results.length === 1) {
                  self.mediaControl.queue = results[0];
                }
              }
            }, 1000);
          })
      }
      else {
        if (inpMode) {
          mode = inpMode;
        }
        self.modeToolbar.setMode(mode);
        window.scrollTo(0, 0);
        setTimeout(() => {
          self.setState({
            searchResults: self.dataSource[mode],
          });
        }, 300);
      }
    });
  }

  playMedia(mp3Obj, index, offset, noteIdx) {
    this.mediaControl.playMedia(mp3Obj, index, offset, noteIdx);
  }

  renewLike(data) {
    var likes = {};
    data.forEach((obj) => {
      likes[obj._id] = true;
    });
    localStorage.setItem("myLikes" + localStorage.getItem('lang'), JSON.stringify(likes));
  }

  payloadTicker() {
    if (this.payloadList.length > 0) {
      this.payloadRunning = true;
      var payload = this.payloadList.pop();
      Common.sendPayloadMessage(payload).then(() => {
        if (this.payloadList.length > 0) {
          this.payloadTicker();
        }
      }, () => {
        this.payloadList.push(payload);
      });
    }
  }

  mangeLikeFromMp3Id(mp3Id, action) {
      var searchResults = JSON.parse(JSON.stringify(this.state.searchResults));
      for (var i = 0; i < searchResults.length; i++) {
        if (searchResults[i]._id === mp3Id) {
          if (searchResults[i].nLike) {
            if (action === 'create') {
              searchResults[i].nLike += 1;
            }
            else if (action === 'delete') {
              if (searchResults[i].nLike > 0)
                searchResults[i].nLike -= 1;
            }
          }
          else {
            if (action === 'create') {
              searchResults[i].nLike = 1;
            }
          }
        }
      }
      return searchResults;
  }

  touchLike(mp3Id) {
    var clonseObj = JSON.parse(JSON.stringify(this.state.myLikes));
    var payload = {'topic': 'like'};
    payload.mp3Id = mp3Id;
    var searchResults;
    if (!clonseObj[mp3Id]) {
      clonseObj[mp3Id] = true;
      payload.action = 'create';
      searchResults = this.mangeLikeFromMp3Id(mp3Id, 'create');
    }
    else {
      delete clonseObj[mp3Id];
      payload.action = 'delete';
      searchResults = this.mangeLikeFromMp3Id(mp3Id, 'delete');
    }
    this.payloadList.unshift(payload);
    this.payloadTicker();
    this.setState({
      myLikes: clonseObj,
      searchResults: searchResults
    });
    localStorage.setItem("myLikes" + window.localStorage.getItem('lang'), JSON.stringify(clonseObj));
  }

  touchAddPlaylist(mp3Obj) {
    var clonseObj = JSON.parse(JSON.stringify(this.state.myPlayList));
    var payload = {'topic': 'playlist'};
    payload.mp3Id = mp3Obj._id;
    if (!clonseObj[mp3Obj._id]) {
      clonseObj[mp3Obj._id] = mp3Obj;
      clonseObj[mp3Obj._id].timeToAddList = new Date().getTime();
      payload.action = 'create';
      payload.timeToAddList = clonseObj[mp3Obj._id].timeToAddList;
    }
    else {
      delete clonseObj[mp3Obj._id];
      if (this.mediaControl.state.mp3PlayingObj && mp3Obj._id === this.mediaControl.state.mp3PlayingObj._id) {
        this.mediaControl.setState({ playListIdx: -1 });
      }
      payload.action = 'delete';
    }
    this.payloadList.unshift(payload);
    this.payloadTicker();
    this.setState({
      myPlayList: clonseObj
    });
    localStorage.setItem("myPlayList" + window.localStorage.getItem('lang'), JSON.stringify(clonseObj));
  }

  deletePlayList(id, idx) {
    delete this.state.myPlayList[id];
    this.setState({
      myPlayList: this.state.myPlayList,
    });
    localStorage.setItem("myPlayList", JSON.stringify(this.state.myPlayList));
  }

  searchAuthor(name) {
    this.mainToolbar.handleUpdateInput(name);
    this.actionSearch(name, 'person');
  }

  copyLink(link) {
    this.setState({
      snackOpen: true,
      snackMessage:Common.getTitleList()['copyLinkText']
    });
    copy(link);
  }

  handleRequestClose() {
    this.setState({
      snackOpen: false,
    });
  };

  showSnackMessage(message) {
    this.setState({
      snackOpen: true,
      snackMessage: message
    });
  }

  handleQRClose() {
    this.setState({
      qrOpen: false,
      qrMediaObj: null,
      qrShareUrl: null
    });
  }

  saveQRCode() {
    html2canvas(document.getElementById('qrimage')).then((canvas) => {
      this.saveAs(canvas.toDataURL(), 'dhammalifeQRCode.png');
      this.handleQRClose();
    });
  }

  saveAs(uri, filename) {
    var link = document.createElement('a');
    if (typeof link.download === 'string') {
        link.href = uri;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

    } else {
        window.open(uri);
    }
  }

  openQRDialog(mediaObj, shareUrl) {
    this.setState({
      qrOpen: true,
      qrActions: [
        <FlatButton
          label={Common.getTitleList()['cancel']}
          labelStyle={{color:'#888888'}}
          onClick={this.handleQRClose.bind(this)}
        />,
        <FlatButton
          label={Common.getTitleList()['download']}
          labelStyle={{color:'#2196F3'}}
          primary={true}
          onClick={this.saveQRCode.bind(this)}
        />,
      ],
      qrMediaObj: mediaObj,
      qrShareUrl: shareUrl
    });
  }

  getQRContent() {
    if (!this.state.qrMediaObj) {
      return (<div></div>);
    } else {
      var profileImage = process.env.PUBLIC_URL + this.state.qrMediaObj.authorImage;
      return (
        <div id="qrimage" style={{width:'260px', marginLeft:'auto', marginRight:'auto', backgroundColor:'#FFF'}}>
          <table style={{width:'260px', paddingTop:'3px'}}><tbody><tr>
            <td style={{textAlign:'center'}}><img src={profileImage} alt={this.state.qrMediaObj.authorTitle} style={{width:'120px'}} /></td>
            <td style={{textAlign:'center'}}><QRCode size={120} value={this.state.qrShareUrl} /></td>
          </tr></tbody></table>
          <div style={{backgroundColor:'#FF9800', width:'100%', color:'#FFF'}}>
            <div style={{padding: '8px', width:'244px'}}>
              <span style={{fontSize: '15px', textAlign:'justify', fontFamily: 'serif'}}>{this.state.qrMediaObj.title}</span> <br />
              <span style={{fontSize: '12px'}}>{Common.getTitleList()['by']} {this.state.qrMediaObj.authorName} </span>
            </div>
          </div>
        </div>
      );
    }
  }



  render() {
    var defaultLayout = {'position':'absolute', 'left':'50%', 'width':'500px', 'marginLeft':'-250px'};
    if (Common.isMobile()) {
      defaultLayout = {'position':'absolute', 'left':'5%', 'width':'90%'}
    }
    var mode = this.modeToolbar ? this.modeToolbar.state.mode : '';
    var allTitle = Common.getTitleList();
    var topicIcon = mode === 'person' ?
      <SocialGroup color="#2196F3"/> : ( mode === 'history' ?
      <ActionHistory color="#2196F3"/> : (mode === 'like' ?
      <ActionFavoriteBorder color="#2196F3"/> : ''));
    var topicTitle = mode === 'person' ?
      allTitle.ajahn : ( mode === 'history' ?
      allTitle.history: (mode === 'like' ?
      allTitle.like : ''));

    var listData = this.state.searchResults ? this.state.searchResults : [];
    return (
      <div>
            <MainToolbar parent={this} />
            <Loading parent={this}/>
            <MediaRelation parent={this} />
            <br />
            <br />
            <br />
            <br />
            <div style={defaultLayout}>
              <ModeToolbar parent={this} />
              { mode === 'person' || mode === 'history' || mode === 'like' ?
              <table style={{marginTop:8, marginBottom: -8}}>
                <tbody><tr><td>{topicIcon}</td><td style={{paddingLeft:8}}><div style={{marginTop:-7, color:"#454545", fontSize:16}}>{topicTitle}</div></td></tr></tbody>
              </table> : <div></div>
              }
              <div style={{ padding: 4 }}></div>
              {
                listData.map((mediaObj, idx) => {
                  var profileImage = process.env.PUBLIC_URL + mediaObj.authorImage;
                  var fontSize = 19;
                  var imageSize = 48;
                  var notes = mediaObj.notes ? mediaObj.notes : [];
                  if (Common.isMobile()) {
                    fontSize = 17;
                    imageSize = 46;
                  }
                  if (!mediaObj.authorImage)
                    profileImage = process.env.PUBLIC_URL  + 'images/account.png';
                    var shareUrl = 'https://' + window.location.hostname + '/index.html?q=' + mediaObj._id;
                    if (window.location.port === '3000' | window.location.port === '5000')
                      shareUrl = 'https://' + window.location.hostname + ':' + window.location.port + '/index.html?q=' + mediaObj._id;
                  return (
                    <div style={{marginTop: '0px', borderBottom: '1px solid #f0ece6' }} key={mediaObj._id+idx}>
                      <Paper zDepth={0}>
                        <table style={{paddingTop:'8px', paddingLeft:'16px', paddingRight:'16px', fontSize:fontSize, color:'#333'}}><tbody><tr>
                        <td style={{width: (imageSize+10), verticalAlign: 'top'}}>
                          <img src={profileImage} alt={mediaObj.authorTitle} style={{width:imageSize, borderRadius:imageSize/2, marginTop: 5}} />
                        </td>
                        <td>
                          <div>
                            <div style={{cursor:'pointer', color:'#535353'}} onTouchTap={!Common.isMobile() ? this.playMedia.bind(this, mediaObj) : null}>{mediaObj.title}</div>
                            <div style={{fontSize:(fontSize-4), color:'#607D8B', marginTop:'6px', cursor:'pointer'}} onClick={this.searchAuthor.bind(this, mediaObj.authorName)}>{mediaObj.authorName}</div>
                            {
                                window.localStorage.getItem('lang') === 'TH' ?
                                <div style={{fontSize:(fontSize-6), color:'#999', marginTop:'6px'}}>
                                    ฟัง {Common.numberWithCommas(mediaObj.nListen)}
                                    {mediaObj.nLike > 0 ? <span> &nbsp;&nbsp;&bull;&nbsp;&nbsp; ชอบ {Common.numberWithCommas(mediaObj.nLike)}</span> : <span></span>}
                                    {mediaObj.duration ? <span style={{marginLeft:14, paddingTop:1, paddingLeft:2, paddingRight:2, border:'1px solid #CCCCCC', fontSize: (fontSize-8)}}>
                                      {Common.convertSecondToHour(mediaObj.duration)}
                                      </span> : <span></span>}
                                </div>
                              :
                                <div style={{fontSize:(fontSize-6), color:'#999', marginTop:'6px'}}>
                                  {Common.numberWithCommas(mediaObj.nListen)}&nbsp;&nbsp;{mediaObj.nListen > 1 ? 'listens' : 'listen'}
                                  {mediaObj.nLike > 0 ? <span> &nbsp;&nbsp;&bull;&nbsp;&nbsp; {Common.numberWithCommas(mediaObj.nLike)}&nbsp;&nbsp;{mediaObj.nLike > 1 ? 'likes' : 'like'}</span> : <span></span>}
                                  {mediaObj.duration ? <span style={{marginLeft:14, paddingTop:1, paddingLeft:2, paddingRight:2, border:'1px solid #CCCCCC', fontSize: (fontSize-8)}}>
                                    {Common.convertSecondToHour(mediaObj.duration)}
                                    </span> : <span></span>}
                                </div>
                            }
                          </div>
                          </td></tr>
                          <tr><td colSpan="2">
                          {
                            notes.map((noteObj, idx) => {
                              var noteTime = ((noteObj.minute * 60) + noteObj.second);
                              return (
                                <table style={{width:"100%", marginTop:8}} key={idx}><tbody>
                                  <tr><td style={{textAlign:'right', paddingRight:8, fontSize:(fontSize-8), color:'#999'}}> {Common.convertSecondToHour(noteTime)} </td><td width="30"></td></tr>
                                  <tr><td>
                                  <div style={{fontSize:(fontSize-4),
                                    backgroundColor:'#f2f2f2',
                                    paddingLeft:16,
                                    paddingRight:16,
                                    paddingTop:8,
                                    paddingBottom:8,
                                    borderRadius:8}}>
                                    {noteObj.title}
                                  </div></td>
                                  <td width="30">
                                    <IconButton onClick={this.playMedia.bind(this, mediaObj, -1, noteTime, idx + 1)}>
                                      <AvPlayCircleOutline />
                                    </IconButton>
                                  </td></tr></tbody></table>
                              );
                            })
                          }
                        </td>
                        </tr>
                        </tbody></table>
                        <table width="100%"><tbody>
                          <tr>
                            <td width="50">
                              <IconButton onClick={this.playMedia.bind(this, mediaObj)} iconStyle={{fill: '#535353'}}>
                                <AvPlayCircleOutline />
                              </IconButton>
                            </td>
                            <td width="50">
                              <IconButton onClick={this.touchLike.bind(this, mediaObj._id)} iconStyle={this.state.myLikes[mediaObj._id] ? {fill: '#FF9800'} : {fill: '#535353'}}>
                                <ActionFavoriteBorder />
                              </IconButton>
                            </td>
                            <td width="55">
                              <IconButton onClick={this.touchAddPlaylist.bind(this, mediaObj)} iconStyle={this.state.myPlayList[mediaObj._id] ? {fill: '#FF9800'} : {fill: '#535353'}}>
                                <AvPlayListAdd />
                              </IconButton>
                            </td>
                            <td width="30">
                              <FacebookShareButton url={shareUrl}>
                                <FacebookIcon size={20} round />
                              </FacebookShareButton>
                            </td>
                            <td width="50">
                              <IconButton onClick={this.copyLink.bind(this, shareUrl)} iconStyle={{fill: '#535353'}}>
                                <ContentLink />
                              </IconButton>
                            </td>
                            <td width="50">
                              <IconButton onClick={this.openQRDialog.bind(this, mediaObj, shareUrl)} iconStyle={{fill: '#535353'}} >
                                <QRCode size={20} value="dhamma" />
                              </IconButton>
                            </td>
                            <td style={{fontSize:(fontSize-8), textAlign:'right', color:'#999'}}>
                            </td>
                          </tr>
                        </tbody></table>
                      </Paper>
                    </div>
                  )
                })
              }
              { this.modeToolbar && (
                this.modeToolbar.state.mode === 'person'
                || this.modeToolbar.state.mode === 'like'
                || this.modeToolbar.state.mode === 'history')
                && listData.length !== 0 ? <div><PageTab parent={this} /><br /><br /><br /></div> : <div></div>}
              <br />
              <br />
              <br />
              <br />
              <br />
              <br />
            </div>
            <Snackbar
              open={this.state.snackOpen}
              message={this.state.snackMessage}
              bodyStyle={{textAlign:'center', backgroundColor:'#0288D1'}}
              autoHideDuration={4000}
              onRequestClose={this.handleRequestClose.bind(this)}
            />
            <Dialog
              actions={this.state.qrActions}
              modal={true}
              open={this.state.qrOpen}
              onRequestClose={this.handleQRClose}
              bodyStyle={{backgroundColor: '#cccccc', padding:'16px 0px'}}
              autoScrollBodyContent={true}
            >
              { this.getQRContent() }
            </Dialog>
            <MediaControl myLikes={this.state.myLikes} myPlayList={this.state.myPlayList} parent={this} />
      </div>
    );
  }
}

export default Main



// WEBPACK FOOTER //
// ./src/Main.js